<template src="./CoreEPICContact.html">
</template>

<script>

  import { mask } from "vue-the-mask"
  import list from "@/components/core/CoreBMSMatchList"
  import coreAddressComponent from "@/components/core/CoreAddress"
  import * as common from "@/common";

  export default {
    components: {
      list,
      'core-address-section': coreAddressComponent
    },
    directives: {
      mask
    },
  name: "core-epic-contact-component",
  props: {
    name: {
      type: String
    },
    index: {
      type: Number
    },
    integrationData: {
      type: Object
    },
    newClient: {
      type: String
    },
    dataArray: {
      type: Array
    },
    contact: {
      type: Object
    },
    uniqueEmailErrorFlag: {
      type: Boolean
    },
    forceUpdate: {
      type: Number
    },
    showErrors: {
      type: Boolean
    }
  },
    data() {
      return {
        datePickerFormat: this.$t("DatePickerFormat"),
        datePickerMask: this.$t("DatePickerMask"),
        dobDatePickerMask: this.$t("DOBDatePickerMask"),
        newContact: 'donotsync',
        contactTableList: {
          mainHeader: "Current Contacts",
          idProperty: "contactId",
          filterOn: [],
          filter: null,
          currentPage: 1,
          fields: [
            { key: "checkbox", label: "", sortable: false },
            { key: "firstName", label: this.$t("FirstName"), sortable: true },
            { key: "lastName", label: this.$t("LastName"), sortable: true },
            { key: "email", label: this.$t("Email"), sortable: true },
            { key: "title", label: this.$t("Title"), sortable: true }
          ],
          initialValue: null
        },
        epicContactTableList: {
          mainHeader: this.$t("CurrentContacts"),
          idProperty: "contactID",
          filterOn: [],
          filter: null,
          currentPage: 1,
          fields: [
            { key: "checkbox", label: "", sortable: false },
            { key: "firstName", label: this.$t("FirstName"), sortable: true },
            { key: "lastName", label: this.$t("LastName"), sortable: true },
            { key: "contactInfo.email1", label: this.$t("Email"), sortable: true },
            { key: "title", label: this.$t("Title"), sortable: true }
          ],
          initialValue: null
        },
        phoneMask: '(###) ###-####',
        genderOptions: [
            {
              id: 'Male',
              name: this.$t("Male")
            },
            {
              id: 'Female',
              name: this.$t("Female")
            }
          ],
        maritalOptions: [
          {
            id: 'Divorced',
            name: this.$t("Divorced")
          },
          {
            id: 'DomesticPartner',
            name: this.$t("DomesticPartner")
          },
          {
            id: 'Married',
            name: this.$t("Married")
          },
          {
            id: 'Single',
            name: this.$t("Single")
          },
          {
            id: 'Widowed',
            name: this.$t("Widowed")
          },
          {
            id: 'Separated',
            name: this.$t("Separated")
          }
        ],
        showDuplicateEmailError: false
      };
    },
    watch: {
      newContact: function (newVal) {
        if (newVal) {
          if (newVal != 'match') {
            this.contact.matchedContactID = 0;
            this.clearSelections();
          }
          this.contact.newContact = newVal;
        }
        this.$emit('checkEmails', this.contact.contactID);
      },
      newClient: function (newVal) {
        if (newVal && newVal == 'create')
					this.newContact = 'create';
        else
          this.newContact = 'donotsync';
      },
      "contact.email": function (newVal) {
        this.$emit('checkEmails', this.contact.contactID);
      },
      "contact.primaryContact": function (newVal) {
        if(newVal == true)
          this.$emit('primaryChanged', this.contact.contactID);
      },
      uniqueEmailErrorFlag: function (newVal) {
        this.showDuplicateEmailError = newVal;
      },
      forceUpdate: function (newVal) {
        this.$forceUpdate();
      }
    },
    mounted() {
      if(this.integrationData.contacts.length == 1){
        this.contact.primaryContact = true;
        if (this.integrationData.targetSystem == 'BP' && this.integrationData.contacts[0].bpPrimaryKey)
          this.contactTableList.initialValue = this.integrationData.contacts[0].bpPrimaryKey
        else if (this.integrationData.targetSystem == 'EPIC' && this.integrationData.epicDestination == 'US' && this.integrationData.contacts[0].epicusPrimaryKey)
          this.epicContactTableList.initialValue = this.integrationData.contacts[0].epicusPrimaryKey;
        else if (this.integrationData.targetSystem == 'EPIC' && this.integrationData.epicDestination == 'CA' && this.integrationData.contacts[0].epiccaPrimaryKey)
          this.epicContactTableList.initialValue = this.integrationData.contacts[0].epiccaPrimaryKey;
      } else {
        if(this.contact.contactID === this.integrationData.opportunity.parentContactID){
          this.contact.primaryContact = true;
        }else{
          this.contact.primaryContact = false;
        }
        
        const matching = this.integrationData.contacts.find(x=>x.contactID === this.contact.contactID);
        if(matching !== null && matching !== undefined){
          if (this.integrationData.targetSystem == 'BP' && matching.bpPrimaryKey)
            this.contactTableList.initialValue = matching.bpPrimaryKey
          else if (this.integrationData.targetSystem == 'EPIC' && this.integrationData.epicDestination == 'US' && matching.epicusPrimaryKey)
            this.epicContactTableList.initialValue = matching.epicusPrimaryKey;
          else if (this.integrationData.targetSystem == 'EPIC' && this.integrationData.epicDestination == 'CA' && matching.epiccaPrimaryKey)
            this.epicContactTableList.initialValue = matching.epiccaPrimaryKey;
        }
      }

      if (this.newClient == 'create')
        this.newContact = 'create';
      else if (this.newClient == 'match')
        this.newContact = 'match';

    },
    computed: {
      duplicateEmail: function () {
        var email = this.contact.email;
        if (email) {
          var numMatches = this.integrationData.contacts.filter(x => x.email == email && (x.newContact && x.newContact != 'donotsync')).length;
          if (numMatches > 1) {
            //this.integrationData.contacts.forEach((item, index) => {
            //  if (item.email == email && (item.newContact && item.newContact != 'donotsync'))
            //    item.showEmailNotUniqueError = true;
            //  else
            //    item.showEmailNotUniqueError = false;
            //});
            return true;
          } else {
            //this.integrationData.contacts.forEach((item, index) => {
            //  item.showEmailNotUniqueError = false;
            //});
            return false;
          }
        }
      }
    },
    methods: {
      emailInputClass(validationClass) {
        // Don't apply any validation styles when the field is empty
        if (!this.contact.email) return '';
        return validationClass;
      }
,
      clearSelections() {
        let app = this;
        if (app.dataArray[app.index] && app.dataArray[app.index].length > 0) {
          app.dataArray[app.index].forEach(unselect);
          function unselect(item, index) {
            if (item.isSelected)
              item.isSelected = false;
          }
        }
      },
      contactChanged(contactID) {
        let app = this;
        this.initialValue = null;
        this.contact.matchedContactID = contactID;
      },
      showUniqueEmailError() {
        let retVal = false;

        if (this.dataArray[this.index] && this.dataArray[this.index].length > 0 && this.newContact == 'create' && this.newClient != 'create') {
          var matchingEmailContact = null;
          if (this.integrationData.targetSystem != 'BP') {
            matchingEmailContact = this.dataArray[this.index].find(x => x.contactInfo.email1 == this.contact.email);
          } else {
            matchingEmailContact = this.dataArray[this.index].find(x => x.email == this.contact.email);
          }
          if (matchingEmailContact) {
            if (this.integrationData.targetSystem != 'BP') {
              //if (matchingEmailContact.contactID != this.contact.matchedContactID) {
                retVal = true;
              //}
            } else {
              //if (matchingEmailContact.contactId != this.contact.matchedContactID) {
                retVal = true;
              //}
            }
          }
        }

        this.contact.hasValidationError = retVal;

        return retVal;
      },
      callForceCorrectDate(event, vmodel, property) {
        common.forceCorrectDate(event, vmodel, property);
      },
      refreshSelfTest() {
        this.$forceUpdate();
      },
      hasContactNotSelectedError() {
        return this.integrationData.syncContact && this.newContact == 'match' && this.contact.matchedContactID == 0;
      }
    }
};
</script>
